import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Alert, Modal, Select } from "barte-design-system";
import { InfoIcon } from "@phosphor-icons/react";

import { getPlanTypeOptions } from "./modal-set-default-plan.constants";
import styles from "./modal-set-default-plan.module.css";
import type { ModalSetDefaultPlanProps } from "./modal-set-default-plan.type";

export const ModalSetDefaultPlan = ({
    isOpen,
    onClose,
    onConfirm,
    isLoading,
}: ModalSetDefaultPlanProps) => {
    const { t } = useTranslation();
    const [planType, setPlanType] = useState<"EARLY" | "TIMELINE">("EARLY");

    const planTypeOptions = getPlanTypeOptions(t);

    useEffect(() => {
        if (!isOpen) {
            setPlanType("EARLY");
        }
    }, [isOpen]);

    const handleConfirm = () => {
        onConfirm(planType);
    };

    const title = (
        <div className={styles["modal-header"]}>
            <InfoIcon weight="regular" size={24} /> {t("backoffice.pageModalSetDefaultPlanTitle")}
        </div>
    ) as unknown as string;

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title={title}
            size="sm"
            footer={{
                primaryButton: {
                    children: t("backoffice.pageModalSetDefaultPlanConfirmButton"),
                    onClick: handleConfirm,
                    disabled: isLoading,
                    loading: isLoading,
                },
                secondaryButton: {
                    children: t("backoffice.pageModalSetDefaultPlanCancelButton"),
                    variant: "outline",
                    onClick: onClose,
                    disabled: isLoading,
                },
                buttonLayout: "hug",
            }}
        >
            <div className={styles.content}>
                <div className={styles.field}>
                    <Select
                        label={t("backoffice.pageModalSetDefaultPlanLabelType")}
                        options={planTypeOptions}
                        value={planType}
                        onChange={(value) => setPlanType(value as "EARLY" | "TIMELINE")}
                        hidePrefixIcon
                    />
                </div>

                <Alert
                    title=""
                    description={
                        <>
                            {t("backoffice.pageModalSetDefaultPlanWarningFirstPart")}{" "}
                            <strong>{t("backoffice.pageModalSetDefaultPlanWarningStrongPart")}</strong>{" "}
                            {t("backoffice.pageModalSetDefaultPlanWarningSecondPart")}
                        </> as unknown as string

                    }
                    variant="warning"
                    showCloseButton={false}
                />


            </div>
        </Modal>
    );
};
